import { EMPLOYER_BLOCKS_FETCH_BEGIN } from './action-types'
import type { FetchEmployerBlocksPayload } from './types'

export const fetchEmployerBlocks = (payload: FetchEmployerBlocksPayload) => ({
  type: EMPLOYER_BLOCKS_FETCH_BEGIN as typeof EMPLOYER_BLOCKS_FETCH_BEGIN,
  payload,
})
export type FetchEmployerBlocksAction = ReturnType<typeof fetchEmployerBlocks>
